import { type ReduxStateShared } from '~shared/types';

export default (state: ReduxStateShared) => state.auth;
